export default "__VITE_ASSET__c2dcf5e3__"